import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-site-down',
  templateUrl: './site-down.component.html',
  styleUrls: ['./site-down.component.scss']
})
export class SiteDownComponent implements OnInit {

  constructor(public _ui: UtilsService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    _ui.startListener(changeDetectorRef, media);
  }

  ngOnInit() {
  }

}
